import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  width: 100%;
  font-size: 14px;

  @media (max-width: 1024px) {
    width: auto;
  }

  .select__control {
    border-radius: 0px;
    border-color: ${colors.borderSelect};
    background-color: transparent;
  }

  .select__control--is-focused {
    border-color: ${colors.borderSelect} !important;
    box-shadow: 0 0 0 1px ${colors.borderSelect} !important;
  }

  .select__option:hover {
    background-color: ${colors.lightGrey};
  }

  .select__option--is-selected {
    background-color: ${colors.borderSelect} !important;
  }

  .select__option--is-focused {
    background-color: ${colors.lightGrey};
  }

  .select__indicator-separator {
    background-color: transparent;
  }

  .select__menu {
    z-index: 5 !important;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Select/style.js